import { render } from "./AdministrationNavbar.vue?vue&type=template&id=ce0b067c"
import script from "./AdministrationNavbar.vue?vue&type=script&lang=js"
export * from "./AdministrationNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__